/**
 * Broker metadata for OxSecurities
 */
export const OxSecuritiesBroker = {
    id: 'oxsecurities',
    name: 'OxSecurities',
    timezone: 'Australia/Sydney',
    logo: 'https://oxsecurities.com/wp-content/uploads/2022/06/ox-logo.svg',
    description: 'OxSecurities Pty Ltd - Australian-based forex broker',
    active: true,
};
/**
 * Repository of all supported brokers
 */
export class AllBrokerRepo {
    /**
     * Get all active brokers
     */
    static getAllBrokers() {
        return this.brokers.filter(b => b.active);
    }
    /**
     * Get broker by ID
     */
    static getBrokerById(id) {
        return this.brokers.find(b => b.id === id);
    }
    /**
     * Get default broker (first active broker)
     */
    static getDefaultBroker() {
        const activeBrokers = this.getAllBrokers();
        if (activeBrokers.length === 0) {
            throw new Error('No active brokers configured');
        }
        return activeBrokers[0];
    }
}
AllBrokerRepo.brokers = [
    OxSecuritiesBroker,
    // Add more brokers here as needed
];
